import { initializeApp, getApps, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

let app: FirebaseApp | null = null;
let auth: Auth | null = null;

export function getFirebaseAuth(): Auth | null {
  if (auth) return auth;
  const hasConfig = config.apiKey && config.projectId && config.authDomain;
  if (!hasConfig) return null;
  if (getApps().length === 0) app = initializeApp(config);
  else app = getApps()[0] as FirebaseApp;
  auth = getAuth(app!);
  return auth;
}

export function isFirebaseConfigured(): boolean {
  return !!(config.apiKey && config.projectId && config.authDomain);
}
